import React from "react";

export const ValidationError = ({ errors, touched, propName }) => {
  return (
    <>
      {errors[`${propName}`] && touched[`${propName}`] ? (
        <div className="invalid-feedback d-block">
          {`${errors[`${propName}`]}`}
        </div>
      ) : null}
    </>
  );
};
